export var AssetsList = ["WETH", "WBTC", "USDC", "yvUSDC"];
//# sourceMappingURL=types.js.map